<!--
  ~ Copyright (c) 1999 - 2020 Accorto, Inc. - All rights reserved.
  -->

<div>
  <button (click)="onSelectProject()"
          class="slds-button slds-button_brand slds-m-bottom_small"
          id="project-select">
    <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
      <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#search"></use>
    </svg>
    <span i18n>Select a Project</span>
  </button>
  <button (click)="onEditProject()"
          *ngIf="isEditProject"
          class="slds-button slds-button_neutral slds-m-bottom_small"
          id="project-edit">
    <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
      <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#edit"></use>
    </svg>
    <span i18n>Edit Project</span>
  </button>
  <button (click)="onEditProject()"
          *ngIf="!isEditProject"
          class="slds-button slds-button_neutral slds-m-bottom_small"
          id="project-new">
    <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
      <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#new"/>
    </svg>
    <span i18n>New Project</span>
  </button>
</div>
<acc-modal-float (closing)="onProjectSelected($event === true ? undefined : null)"
                 *ngIf="showProjectSelect"
                 i18n-title title="Select Project">
  <acc-data-record-selector (recordSelected)="onProjectSelected($event)"
                            [columnNames]="projectSelectColumns"
                            [records]="projectRecords"></acc-data-record-selector>
</acc-modal-float>
<psa-project-editor (editorClosed)="onEditProjectClose()"
                    *ngIf="showProjectEdit && project"
                    [recordI]="project">
</psa-project-editor>


<div *ngIf="!iframeConfirmed && project">
  <button (click)="onLoadProject()"
          class="slds-button slds-button_outline-brand" i18n>Load Project: {{projectLabel}}</button>
</div>

<div *ngIf="iframeConfirmed && project">
  <h1 class="slds-text-heading_medium" id="project-label">{{projectLabel}}</h1>
  <div class="slds-float_right">
    <button (click)="onRefresh()"
            class="slds-button slds-button_icon slds-button_icon-border"
            id="project-refresh"
            title="Refresh">
      <svg aria-hidden="true" class="slds-button__icon">
        <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#refresh"></use>
      </svg>
      <span class="slds-assistive-text" i18n>Refresh</span>
    </button>
  </div>

  <h2 class="slds-text-heading_small slds-m-top_small" i18n>Effort/Hours</h2>
  <div class="slds-scrollable_x slds-p-bottom_medium">
    <psa-stacked-bar-chart [definition]="hoursDefinition"
                           [dimensions]="hoursDimensions"
                           [sources]="hoursSources"
                           id="project-hours"></psa-stacked-bar-chart>
  </div>

  <h2 class="slds-text-heading_small slds-m-top_small" i18n>Timeline</h2>
  <div class="slds-scrollable_x slds-p-bottom_medium">
    <psa-time-line [definitions]="tlDefinitions"
                   [dimensions]="tlDimensions"
                   [sources]="tlSources"
                   id="project-tl"></psa-time-line>
  </div>


  <div class="slds-m-top_small">
    <psa-project-burn-down id="burn-down">
    </psa-project-burn-down>
  </div>
</div>
